import axios from "axios";

import { EntityKind } from "models/entityKind";

import { IGroupByListColumn, IGroupByListItem } from "../../../models";
import { fetchGeomBins } from "./fetchGeomBins";

const rootUrl = process.env.REACT_APP_COLUMN_SET_SERVICE;

const GeomBinPrefix = "GeomBin";
const UserDefinedColumnPropertyPrefix = "My_Focus_Fields";

export const fetchUserDefinedColumns = async (
  entityKind: EntityKind = EntityKind.Well
): Promise<IGroupByListItem> => {
  let userList: IGroupByListItem = null;

  const userDefinedColumnsResponse = await axios.get(
    `${rootUrl}/user-defined-columns?entityKind=${entityKind}`
  );

  if (userDefinedColumnsResponse.status === 200) {
    userList = userDefinedColumnsResponse.data;
  }

  if (userList && entityKind === EntityKind.Well) {
    const columns = (await fetchGeomBins("isOrg=false")).map((bin) => {
      return {
        title: bin.name,
        id: bin.id,
        canBin: false,
        dataType: "Text",
        canNormalize: false,
        group: GeomBinPrefix,

        subgroup: bin.group,
        property: `${UserDefinedColumnPropertyPrefix}_${GeomBinPrefix}_${btoa(
          bin.group
        )}_${bin.id}`,
        withinSubgroupOrder: bin.withinSubGroupOrder,
        fieldType: "geom"
      } as IGroupByListColumn;
    });

    userList.columns = userList.columns.concat(columns);
  }

  return userList;
};
